import {create} from 'zustand';
import {devtools, persist} from 'zustand/middleware';

export type EvacuationViewMode = 'list' | 'rooms';

type EvacuationState = {
  confirmedIds: Record<string, boolean>;
  absentIds: Record<string, boolean>;
  note: string;
  viewMode: EvacuationViewMode;

  toggleConfirmed: (personId: string) => void;
  toggleAbsent: (personId: string) => void;
  setNote: (note: string) => void;
  setViewMode: (viewMode: EvacuationViewMode) => void;
  reset: () => void;
};

const useEvacuationStore = create<EvacuationState>()(
  devtools(
    persist(
      set => ({
        confirmedIds: {},
        absentIds: {},
        note: '',
        viewMode: 'list',

        toggleConfirmed: personId => {
          set(state => ({
            confirmedIds: {
              ...state.confirmedIds,
              [personId]: !state.confirmedIds[personId],
            },
          }));
        },

        toggleAbsent: personId => {
          set(state => ({
            absentIds: {
              ...state.absentIds,
              [personId]: !state.absentIds[personId],
            },
            confirmedIds: {...state.confirmedIds, [personId]: false},
          }));
        },

        setNote: note => set({note}),

        setViewMode: viewMode => set({viewMode}),

        reset: () => set({confirmedIds: {}, absentIds: {}, note: ''}),
      }),
      {name: 'facility-evacuation'}
    )
  )
);

export default useEvacuationStore;
